import { css } from '@emotion/react'

import { rgba } from 'polished'

import { colors, transitions } from '@/styles/theme'

const BtnGlobalCustomStyles = {
  commonBlock: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  searchNearParking: css`
    position: absolute;
    top: 20px;
    right: 20px;

    html[lang^='ar'] & {
      left: 20px;
      right: unset;
    }
  `,
  tile: css`
    padding: 7px;
    flex-direction: column;
    gap: 10px;
    border-radius: 28px;
    background: ${colors.seaBlue};
    color: ${colors.white};
    text-align: center;
    font-size: 10px;
    font-weight: 900;
    line-height: normal;

    @media (min-width: 768px) {
      font-size: 16px;
      padding: 7px 32px;
    }
  `,
  group: css`
    padding: 11px 36px;
    flex-direction: column;
    gap: 10px;
    border-radius: 28px;
    font-size: 18px;
    line-height: normal;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
    }
  `,
  showResultCommonStyles: css`
    padding: 8px 18px;
    gap: 8px;
    color: ${colors.white};
    font-weight: 900;
    line-height: 18px;
    border-radius: 28px;
  `,
  filter: css`
    width: 50%;
    font-size: 10px;
    background-color: ${colors.twilightBlue};
  `,
  mobileFilter: css`
    width: 280px;
    font-size: 12px;
    background-color: ${colors.darkSkyBlue};
  `,
  searchModal: css`
    width: 100%;
    background: ${colors.seaBlue};
    font-size: 12px;
    margin: 0 auto;
  `,
  optionClose: css`
    color: ${colors.twilightBlue};
    font-size: 16px;
    display: flex;
    width: 60px;
    justify-content: flex-end;
  `,
  noDateSearch: css`
    color: ${colors.seaBlue};
    font-weight: 600;
    margin: 0 auto;
    padding: 8px 0;
    font-size: 12px;
  `,
  clearFilter: css`
    color: ${colors.darkSkyBlue};
    font-weight: 600;
    line-height: 14px;
    font-size: 12px;
  `,
  discoverWrapper: css`
    position: relative;
    pointer-events: all;
    opacity: 1;
    transition: opacity ${transitions.base},
      background-color ${transitions.base};
    color: ${colors.white};
    background-color: ${rgba(colors.paleGrey, 0.5)};

    &.swiper-button-disabled {
      opacity: 0;
      visibility: hidden;
    }

    &:hover {
      background-color: ${rgba(colors.paleGrey, 0.65)};
    }
  `,
  wrapper: css`
    position: relative;
    margin-bottom: 40px;

    @media (min-width: 768px) {
      transform: translate(0, -100%);
      margin-bottom: 16px;
    }

    @media (min-width: 1280px) {
      margin-bottom: 32px;
    }
  `,
  showAll: css`
    text-align: right;
    font-size: 12px;
    line-height: normal;
    align-self: flex-end;
    margin: 0 auto;
    color: ${colors.seaBlue};

    @media (min-width: 768px) {
      font-size: 16px;
    }
  `,
  toggle: css`
    padding: 10px 24px;
    background-color: white;
    margin: 0 8px;
    border-radius: 32px;
    transition: border 0.3s, box-shadow 0.3s;
    width: 78vw;

    @media (min-width: 768px) {
      padding: 10px 128px;
      margin: 0 24px;
      width: unset;
    }
  `,
  month: css`
    width: 2.75em;
    height: 2.75em;

    min-width: 44px;
    min-height: 44px;
  `,
  head: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    text-align: start;

    &:focus:not(:focus-visible) {
      outline: none;
    }

    &:focus-visible {
      outline: 2.5px dashed ${colors.cloudyBlue};
      transition: outline-width 0.1s ease;
      outline-offset: 3px;
    }
  `,
  searchWrapper: css`
    gap: 4px;
    color: white;
    font-size: 14px;
    line-height: 18px;
    border-radius: 40px;
    padding: 12px;
    background: #1574e0;

    img {
      max-height: 22px;
    }

    @media (min-width: 768px) {
      padding: 15px 36px;
      gap: 12px;
      font-size: 18px;
      border-radius: 28px;
    }
  `,
  popupDesktop: css`
    @media (max-width: 1024px) {
      font-size: 12px;
      padding: 8px;
    }
  `,
  popup: css`
    padding: 15px 16px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 900;
    line-height: 18px;
    width: 100%;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      transform: scale(0.98);
    }

    @media (max-width: 768px) {
      padding: 10px 14px;
      font-size: 16px;
      width: 100%;
    }
  `,
  popupDisabled: css`
    background: ${colors.lightGrey};
    color: ${colors.grey};
  `,
  popupEnabled: css`
    background: ${colors.darkSkyBlue};
    color: ${colors.white};
  `,
  treriary: css`
    border-radius: 28px;
    background: ${colors.seaBlue};
    padding: 8px 18px;
    color: ${colors.white};
    font-weight: 800;
    line-height: normal;
    font-size: 10px;

    @media (min-width: 768px) {
      font-size: 13px;
      padding: 8px 16px;
    }

    @media (min-width: 1280px) {
      font-size: 16px;
      padding: 12px 24px;
    }
  `,
  treriaryLarge: css`
    font-size: 14px;
    font-weight: 700;
    padding: 12px 26px;

    @media (min-width: 768px) {
      font-size: 16px;
      padding: 14px 32px;
    }

    @media (min-width: 1280px) {
      font-size: 20px;
      padding: 14px 32px;
    }
  `,
  miniMap: css`
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    border-radius: 28px;
    background: ${colors.seaBlue};
    display: inline-flex;
    padding: 9px 24px;
    font-size: 18px;
    line-height: 18px;
    color: ${colors.white};
    width: max-content;
  `,
  disabledQuickBooking: css`
    border: 2px solid ${colors.blueyGrey};
    color: ${colors.blueyGrey};
    pointerevents: none;
    background: ${colors.white};
  `,
  clearHistory: css`
    font-size: 12px;
    font-weight: 900;
  `,
  bookingDetail: css`
    color: ${colors.seaBlue};
    line-height: normal;
    font-size: 12px;
  `,
  mobileBookingDetail: css`
    font-style: normal;
    font-family: 'Nunito', sans-serif;
    font-weight: 600;
    color: ${colors.darkSkyBlue};
    font-size: 10px;
    line-height: 16px;
    text-align: left;
  `,
  searchClearHistory: css`
    font-size: 16px;
    font-weight: 600;
    color: ${colors.seaBlue};
  `,
  mobileSearchClearHistory: css`
    font-size: 12px;
    font-weight: 900;
    color: ${colors.seaBlue};
  `,
  closeModalWrapper: css`
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
  `
}

export default BtnGlobalCustomStyles
